/**
 * Os poucos valores do protótipo "Code Companion · Trace" que não têm token no app.
 *
 * ✅ Conferido: a esmagadora maioria dos hex do protótipo **já é** token do app —
 * `#08254c` é `--exed-navy`, `#ffc83d` é `--exed-gold`, `#e8ebf0` é
 * `--exed-card-border`, `#596b85` é `--exed-ink-500`, `#7b8799` é `--exed-ink-400`,
 * `#27a155` é `--exed-success`. O `_ds_manifest.json` do bundle declara que o design
 * system foi **extraído do próprio app**, então não há paleta nova a adotar.
 *
 * O que sobra são tons intermediários que o protótipo usa e o app ainda não nomeou.
 * Ficam aqui, num lugar só, em vez de espalhados como hex solto pelos componentes —
 * e cada um aponta a linha do protótipo de onde veio, para conferência.
 */

/** Faixa do maestro. Um navy um passo acima do hero, para separar sem cortar. (l.127) */
export const CC_STRIP_BG = "#0d2e5c";

/** Fundo de cabeçalho e rodapé de tabela. Quase branco, distingue da linha. (l.179) */
export const CC_TABLE_HEAD_BG = "#fafbfc";

/** Divisória interna de linha, mais leve que a borda do card. (l.192) */
export const CC_ROW_DIVIDER = "#f4f6f9";

/** Divisória entre colunas do cabeçalho. (l.181) */
export const CC_COL_DIVIDER = "#eef1f5";

/** Mono apagado: numeração, metadados, chevron. Entre ink-300 e ink-400. (l.194) */
export const CC_MONO_MUTED = "#a3adbd";

/** Chevron e traços decorativos, o tom mais claro em uso. (l.253) */
export const CC_HAIRLINE = "#c3cbd7";

/** Laranja escuro do "needs a human" — o `--exed-warn` escurecido para texto. (l.300) */
export const CC_WARN_INK = "#c25500";

/** Dourado escuro do rótulo de seção sobre fundo claro. (l.152) */
export const CC_GOLD_INK = "#b57a00";
